"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tools = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var memoize = require("fast-memoize");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_redux_1 = require("react-redux");
var translate_1 = require("utils/translate");
var sok_ui_1 = require("@caddigital/sok-ui");
var bidListActions = require("@caddigital/sok-reducers/lib/actions/bid/list");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var Types = require("types");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        list: state.bid.list
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    copy: function (briefcase, bid) {
        return bid && dispatch(bidListActions.copyRequest(bid, briefcase));
    },
    removeRequest: function (bid) {
        return dispatch(bidListActions.removeRequest(bid));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('BidParticipantsTools'), (0, recompose_1.withState)('removeIsOpen', 'setRemoveIsOpen', false), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), react_router_dom_1.withRouter, recompose_1.pure);
var getStatus = memoize(function (selected, list) {
    var selectedBid = selected.length === 1 ? list.find(function (b) { return b.id === selected[0]; }) : null;
    var status = 'confirm';
    if (selectedBid) {
        var statusMeta = selectedBid.customMeta.find(function (x) { return x.identifier === 'bid-status-meta'; });
        var published = statusMeta ? statusMeta.value === 'Published' : false;
        if (published) {
            var endAtMeta = selectedBid.customMeta.find(function (x) { return x.identifier === 'end-at-meta'; });
            if (endAtMeta &&
                endAtMeta.value &&
                typeof endAtMeta.value === 'number' &&
                endAtMeta.value < Date.now()) {
                status = 'confirmFinished';
            }
            else {
                status = 'confirmPublished';
            }
        }
    }
    return status;
});
exports.Tools = enhance(function (props) {
    var status = getStatus(props.list.selected, props.list.list);
    return (React.createElement(sok_ui_1.ToolsSidebarWrap, { className: 'bid-list-view-tools-container' },
        React.createElement(sok_ui_1.ToolsSidebar, { className: 'bidListView/tools', headerText: (0, translation_1.getLocalization)('bidListView/tools/header') },
            React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)(), "/briefcase/").concat(props.currentBriefcase.id, "/bid"), className: 'sok-tool-button green' },
                React.createElement(sok_ui_1.Icon, { className: 'fa-plus sok-tool-button-icon' }),
                React.createElement("span", { className: 'sok-tool-button-text' }, (0, translation_1.getLocalization)('bidListView/tools/createNew'))),
            React.createElement(sok_ui_1.ToolButton, { color: 'red', text: (0, translation_1.getLocalization)('bidListView/tools/delete'), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-trash' }), disabled: props.list.selected.length !== 1, onClick: function () { return props.setRemoveIsOpen(true); } }),
            React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.removeIsOpen, close: function () { return props.setRemoveIsOpen(false); }, header: (0, translation_1.getLocalization)('global/confirmation'), body: React.createElement(React.Fragment, null,
                    React.createElement(ConfirmDialog_1.Exclamation, null),
                    React.createElement("div", null,
                        React.createElement("div", { className: 'title please-confirm-text' },
                            React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('global/pleaseConfirm'))),
                        React.createElement("div", { className: 'text' },
                            React.createElement("p", null, (0, translation_1.getLocalization)("bidListView/remove/".concat(status))),
                            React.createElement("p", null, (0, translation_1.getLocalization)('bidListView/remove/areYouSure'))))), footer: React.createElement(React.Fragment, null,
                    React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('buttons/delete'), onClick: function () {
                            if (props.list.selected.length !== 1) {
                                return;
                            }
                            var selectedLetter = props.list.list.find(function (b) { return b.id === props.list.selected[0]; });
                            if (selectedLetter) {
                                props.setRemoveIsOpen(false);
                                props.removeRequest(selectedLetter);
                            }
                        } }),
                    React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('buttons/cancel'), onClick: function () { return props.setRemoveIsOpen(false); } })) }))));
});
